import React from 'react';
import styled from 'styled-components';
import { themeLight, icons, spacing } from '../../../theme/index';
import { Text, TextVariant } from '../../../text/index';
import { Error } from '@styled-icons/material';
export const Message = ({ children, error = true, className }) => {
    return (<FormMessage className={className} error={error}>
      {error && (<Error />)}
      <Text variant={TextVariant.Small} style={{ margin: 0 }}>{children}</Text>
    </FormMessage>);
};
export default Message;
const FormMessage = styled.span `
  flex-basis: 100%;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.componentColors
    ? theme.componentColors.alert.error
    : themeLight.componentColors.alert.error};

  svg {
    font-size: ${icons.s};
    padding-right: ${spacing.space8};
  }
`;
